module.exports = __webpack_public_path__ + "img/rent-a-tent-no.e7f6888.svg";